import { createSlice } from '@reduxjs/toolkit'
import { defaultTo } from 'ramda'

const slice = createSlice({
  name: 'dtSignalValues',
  initialState: {},
  reducers: {
    setDtSignalValues: (state, { payload }) => {
      state[`${payload.dashboardId}`] = {
        ...defaultTo({}, state[`${payload.dashboardId}`]),
        [payload.dtSignalModel.id]: {
          data: payload.data,
        }
      }
    },
  },
})

export const { setDtSignalValues } = slice.actions

export default slice.reducer

export const selectDtSignalValues = (dashboardId, signalId) => (state) =>
  state.dtSignalValues?.[dashboardId]?.[signalId]?.data
